import { memo } from 'react';
import Markdown from 'react-markdown';
import type { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

// react-markdown rendert kein Raw-HTML, Agent-Antworten sind damit XSS-sicher
const components: Components = {
  p: ({ children }) => <p className="mb-3 last:mb-0">{children}</p>,
  h1: ({ children }) => <p className="mb-2 font-semibold">{children}</p>,
  h2: ({ children }) => <p className="mb-2 font-semibold">{children}</p>,
  h3: ({ children }) => <p className="mb-2 font-semibold">{children}</p>,
  hr: () => <hr className="my-3 border-neutrals-v2-300" />,
  ul: ({ children }) => (
    <ul className="mb-3 list-disc pl-5 last:mb-0">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="mb-3 list-decimal pl-5 last:mb-0">{children}</ol>
  ),
  a: ({ children, href }) => (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="font-semibold text-brand-red-200 underline">
      {children}
    </a>
  ),
  code: ({ children }) => (
    <code className="rounded bg-neutrals-v2-200 px-1 text-xs">{children}</code>
  ),
  // Breite Inhalte scrollen horizontal
  pre: ({ children }) => (
    <pre className="mb-3 overflow-x-auto rounded bg-neutrals-v2-200 p-2 text-xs last:mb-0 [&_code]:bg-transparent [&_code]:p-0">
      {children}
    </pre>
  ),
  table: ({ children }) => (
    <div className="mb-3 overflow-x-auto last:mb-0">
      <table className="w-full border-collapse text-left text-xs">
        {children}
      </table>
    </div>
  ),
  th: ({ children }) => (
    <th className="border-b border-neutrals-v2-300 px-2 py-1 font-semibold">
      {children}
    </th>
  ),
  td: ({ children }) => (
    <td className="border-b border-neutrals-v2-200 px-2 py-1 align-top">
      {children}
    </td>
  ),
};

export const MarkdownText = memo(function MarkdownText({
  text,
}: {
  text: string;
}) {
  return (
    <div className="text-sm leading-5 wrap-break-word text-labels-primary">
      <Markdown remarkPlugins={[remarkGfm]} components={components}>
        {text}
      </Markdown>
    </div>
  );
});
